<template>
  <div>
    <v-card :height="height + ''" v-if="card">
      <v-progress-linear class="loaderProgress" :indeterminate="true" v-if="loading"></v-progress-linear>
      <v-progress-linear class="loaderProgress" :indeterminate="false" color="error" value="100" v-else></v-progress-linear>
      <v-card-text :style="loaderStyle">
        <v-layout fill-height align-center justify-center column v-if="loading">
          <span class="subheading">
            {{loadText}}
          </span>
        </v-layout>
        <v-layout fill-height align-center justify-center column v-else>
          <v-expansion-panel expand class="loaderError" v-if="renderErrors" :value="[true]">
            <v-expansion-panel-content>
              <div slot="header">
                <v-icon color="red">mdi-alert</v-icon>
                {{errorText}}
              </div>
              <v-card>
                <v-card-text class="grey lighten-3">
                  <ul class="errorMsg">
                    <li v-for="(msg, index) in errorMsgs" :key="index">{{msg}}</li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <div v-else>
            <span class="subheading">
              <v-icon color="red">mdi-alert</v-icon>
              {{errorText}}
            </span>
          </div>
          <v-btn color="primary" @click="init" class="mt-3">
            {{retryText}}
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
    <div :style="loaderStyle" v-else>
      <v-layout fill-height align-center justify-center column v-if="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <span class="subheading mt-3">
          {{loadText}}
        </span>
      </v-layout>
      <v-layout fill-height align-center justify-center column v-else>
        <v-expansion-panel expand class="loaderError" v-if="renderErrors" :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon color="red">mdi-alert</v-icon>
              {{errorText}}
            </div>
            <v-card>
              <v-card-text class="grey lighten-3">
                <ul class="errorMsg">
                  <li v-for="(msg, index) in errorMsgs" :key="index">{{msg}}</li>
                </ul>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <div v-else>
          <v-icon color="red" class="mr-2">mdi-alert</v-icon>
          <span class="subheading">
            {{errorText}}
          </span>
        </div>
        <v-btn color="primary" @click="init" class="mt-3">
          {{retryText}}
          <v-icon right>mdi-refresh</v-icon>
        </v-btn>
      </v-layout>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  computed: {
    loaderStyle() {
      return {
        height: this.height + 'px'
      }
    },
    renderErrors() {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  props: {
    card: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    init: {
      type: Function,
      default: () => {
        Vue.prototype.$toast.error('No init method specified')
      }
    },
    height: {
      type: Number,
      default: 200
    },
    loadText: {
      type: String,
      default: 'Loading...'
    },
    errorText: {
      type: String,
      default: 'Failed to load the required resource'
    },
    retryText: {
      type: String,
      default: 'Retry'
    },
    errorMsgs: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
.loaderProgress.progress-linear {
  margin: 0px;
}
.cardLoadText {
  font-weight: 500;
}
.loaderError {
  .expansion-panel__header {
    text-align: center;
  }
  .errorMsg {
    padding-left: 15px;
  }
}
</style>
